import { render, staticRenderFns } from "./shopDeclareMonthInfoList.vue?vue&type=template&id=e5786e0c&scoped=true"
import script from "./shopDeclareMonthInfoList.vue?vue&type=script&lang=ts"
export * from "./shopDeclareMonthInfoList.vue?vue&type=script&lang=ts"
import style0 from "./shopDeclareMonthInfoList.vue?vue&type=style&index=0&id=e5786e0c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5786e0c",
  null
  
)

export default component.exports